import { Subject, BehaviorSubject } from 'rxjs';
import { EventEmitter, Injectable } from '@angular/core'

@Injectable({
  providedIn: 'root'
})
export class SlotsService {
  public daysUpdated = new EventEmitter<string>();
  Slots = new Subject<any>();
  addSlots = new BehaviorSubject<boolean>(false);

  addSlot(slot: boolean) {
    return this.addSlots.next(slot);
  }

  getSlots(slots: any) {
    return this.Slots.next(slots);
  }
}
